import now from './now.js';

export default {
  now
};



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/date.default.js
// module id = 2313
// module chunks = 67